import AuthSignup from './auth-signup';

export default AuthSignup;
